<template>
    <b-container fluid>
        <b-row class="my-3" col>
            <b-col cols="2">
                <label>Name:</label>
            </b-col>
            <b-col cols="3">
                <b-form-input :value="getCurrentCompFactor.name" disabled data-test="name"></b-form-input>
            </b-col>
            <b-col offset="3"></b-col>
            <b-col cols="3">
                <b-button 
                    v-if="getCurrentCompFactor.valid"
                    @click="resetCompFactor"
                    variant="danger" 
                    class="float-right"
                >
                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                        <span>Remove '{{getCurrentCompFactor.name}}'</span>
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="2">
                <label>Comments:</label>
            </b-col>
            <b-col cols="8">
                <b-textarea
                    rows="3"
                    :value="getCurrentCompFactor.message"
                    @input="
                        editCurrentCompFactor({ prop: 'message', value: $event });
                        v$.getCurrentCompFactor['message'].$touch();
                    "
                    :state="inputState('message')"
                    data-test="message"
                ></b-textarea>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { mapGetters, mapMutations } from "vuex";
import { required } from "vuelidate/lib/validators";
import { dialogMixins } from "@/mixins/dialog.js";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    computed: {
        ...mapGetters(["getCurrentCompFactor", "getScenario"]),
    },
    methods: {
        ...mapMutations(["editCurrentCompFactor", "resetOtherCompFactor"]),
        inputState(prop) {
            return !this.v$.getCurrentCompFactor[prop].$error ? null : !this.v$.getCurrentCompFactor[prop].$invalid;
        },
        async resetCompFactor() {
            const confirmation = await this.confirmReset(this.getCurrentCompFactor.name);
            if (confirmation) {
                this.resetOtherCompFactor(this.getCurrentCompFactor.name);
                this.$bvModal.hide('comp-factor');
            }
        }
    },
    mounted() {
        // remove the 'manager required' message from the 'other' comp factor
        if (!this.getCurrentCompFactor.valid) {
            this.editCurrentCompFactor({ prop: 'message', value: ''});
        }
    },
    validations() {
        return {
            getCurrentCompFactor: {
                message: {
                    required,
                },
            },
        };
    },
    mixins: [dialogMixins]
};
</script>

<style scoped>
.form-spacing {
    margin-top: -1.5rem;
    margin-bottom: 0;
}

.btn-ok {
    background-color: #00afef !important;
}
</style>